module.exports = __webpack_public_path__ + "img/tu2.26ae5b36.png";